import {
  type IAdminAuthLogEntry,
  type IAdminProfile,
  type IAdminSessionEntry,
} from '@mahawi/eshop-common';

import { type AsyncState } from '../async-state';

export enum ELoginStatus {
  MAGIC_LINK_SENT = 'magicLinkSent',
  INVALID_CREDENTIALS = 'invalidCredentials',
  COUNTRY_NOT_ALLOWED = 'countryNotAllowed',
  RATE_LIMITED = 'rateLimited',
}

export interface IUserState extends AsyncState {
  isLoggedIn: boolean;
  loginStatus: ELoginStatus | null;
  passwordChanged: boolean;
  authLog: IAdminAuthLogEntry[];
  authLogInProcess: boolean;
  sessions: IAdminSessionEntry[];
  sessionsInProcess: boolean;
  profile: IAdminProfile | null;
  profileInProcess: boolean;
  email?: string;
  uuid?: string;
  username?: string | null;
}

export interface IChangePasswordResponsePayload {
  ok: boolean;
}

export enum EMagicLinkStatus {
  EXPIRED = 'expired',
  COUNTRY_NOT_ALLOWED = 'countryNotAllowed',
}

export const MAGIC_LINK_QUERY_PARAM = 'magicLink';

export enum ESessionStatus {
  EXPIRED = 'expired',
}

export const SESSION_QUERY_PARAM = 'session';
